"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _i18n = _interopRequireWildcard(require("../../../../@i18n"));
var _hooks = require("../../../../@hooks");
var _functions = require("../../../../@functions");
var _firebase = _interopRequireDefault(require("../../../../@api/appcenter/firebase.config"));
var _Icon = _interopRequireDefault(require("../../../../@custom/Icon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var appcenterFirestore = _firebase["default"].firestore();
var licenseConfigCollection = appcenterFirestore.collection('license-configuration');
var opportunityCollection = appcenterFirestore.collection('opportunity');
var supportPhone = '5508006049404';

/** @param {import("../../index").AccountPageProps} props */
function Charge(props) {
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    plan = _useState2[0],
    setPlan = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    opportunities = _useState4[0],
    setOpportunities = _useState4[1];
  var app = props.app,
    auth = props.auth;
  var appLicenses = auth.licenses.filter(function (license) {
    return license.app === app;
  }).map(function (license) {
    return _objectSpread(_objectSpread({}, license), {}, {
      expirationDate: (0, _functions.toDate)(license.expirationDate),
      createdAt: (0, _functions.toDate)(license.createdAt)
    });
  });
  var appPlanLicenses = appLicenses.filter(function (license) {
    return license.isPlan;
  });
  var appFeatureLicenses = appLicenses.filter(function (license) {
    return license.isFeature;
  });
  var _useMemo = (0, _react.useMemo)(function () {
      var _appPlanLicenses = (0, _slicedToArray2["default"])(appPlanLicenses, 1),
        _appPlanLicenses$ = _appPlanLicenses[0],
        firstPlanLicense = _appPlanLicenses$ === void 0 ? {
          planId: "".concat(app, "-free"),
          expirationDate: new Date()
        } : _appPlanLicenses$;
      var planId = firstPlanLicense.planId,
        expirationDate = firstPlanLicense.expirationDate;
      return {
        planId: planId,
        expirationDate: expirationDate
      };
    }, [appPlanLicenses]),
    planId = _useMemo.planId,
    expirationDate = _useMemo.expirationDate;

  /** @type {string[]} */
  var opportunityUids = (0, _react.useMemo)(function () {
    return Array.from(new Set((0, _toConsumableArray2["default"])(appLicenses.filter(function (license) {
      return license.opportunity;
    }).map(function (license) {
      return license.opportunity;
    }))));
  }, [appLicenses]);
  var isExpired = (0, _react.useMemo)(function () {
    if (!expirationDate) return false;
    var today = new Date();
    return today > expirationDate;
  }, [expirationDate]);
  var paidValue = (0, _react.useMemo)(function () {
    return opportunities.reduce(function (sum, opportunity) {
      return sum + opportunity.customerValue;
    }, 0);
  }, [opportunities]);
  var _useMemo2 = (0, _react.useMemo)(function () {
      var storageLicenses = appLicenses.filter(function (license) {
        return license.type === 'storage';
      });
      var isUnlimited = storageLicenses.some(function (license) {
        return license.amount === 'unlimited';
      });
      var usedStorage = storageLicenses.reduce(function (sum, license) {
        return sum + license.used;
      }, 0);
      var totalStorage = isUnlimited ? 'unlimited' : storageLicenses.reduce(function (sum, license) {
        return sum + license.amount;
      }, 0);
      var totalStorageForPercentage = totalStorage === 'unlimited' ? usedStorage + Math.pow(1024, 3) : totalStorage;
      var storagePercentage = usedStorage / totalStorageForPercentage * 100;
      return {
        storagePercentage: storagePercentage,
        totalStorage: totalStorage,
        usedStorage: usedStorage
      };
    }, [appLicenses]),
    storagePercentage = _useMemo2.storagePercentage,
    totalStorage = _useMemo2.totalStorage,
    usedStorage = _useMemo2.usedStorage;
  var progressBarColor = (0, _react.useMemo)(function () {
    if (storagePercentage < 50) return 'info';
    if (storagePercentage >= 50 && storagePercentage < 70) return 'success';
    if (storagePercentage >= 70 && storagePercentage < 80) return 'warning';
    return 'error';
  }, [storagePercentage]);
  var storageExceeded = storagePercentage >= 100;
  var almostReachingLimit = storagePercentage >= 70;
  var handleUpgradePlan = function handleUpgradePlan() {
    (0, _functions.openInWhatsapp)(supportPhone, 'Quero realizar Upgrade do meu plano!');
  };
  var handleCancelPlan = function handleCancelPlan() {
    (0, _functions.openInWhatsapp)(supportPhone, 'Quero realizar Upgrade do meu plano!');
  };
  (0, _hooks.useAsyncEffect)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var doc, data;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (planId) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          _context.next = 4;
          return licenseConfigCollection.doc(planId).get();
        case 4:
          doc = _context.sent;
          data = doc.data();
          setPlan(data || {});
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [planId]);
  (0, _hooks.useAsyncEffect)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var ops, _iterator, _step, uid, doc, data;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          ops = [];
          _iterator = _createForOfIteratorHelper(opportunityUids);
          _context2.prev = 2;
          _iterator.s();
        case 4:
          if ((_step = _iterator.n()).done) {
            _context2.next = 13;
            break;
          }
          uid = _step.value;
          _context2.next = 8;
          return opportunityCollection.doc(uid).get();
        case 8:
          doc = _context2.sent;
          data = doc.data();
          ops.push(data || {});
        case 11:
          _context2.next = 4;
          break;
        case 13:
          _context2.next = 18;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](2);
          _iterator.e(_context2.t0);
        case 18:
          _context2.prev = 18;
          _iterator.f();
          return _context2.finish(18);
        case 21:
          setOpportunities(ops);
        case 22:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 15, 18, 21]]);
  })), [opportunityUids]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-charge"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-charge-left"
  }, plan.uid && /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-charge-container"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "Account-title"
  }, "Plano atual"), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "Account-subtitle"
  }, "SEU PLANO ATUAL \xC9 ", plan.description.toUpperCase()), appPlanLicenses.map(function (license) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "Account-text"
    }, (0, _i18n["default"])("license.type.".concat(license.type)), ": ", /*#__PURE__*/_react["default"].createElement("b", null, (0, _functions.displayLicenseAmount)(license)));
  })), appFeatureLicenses.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-charge-container"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "Account-title"
  }, "Recursos adicionais"), appFeatureLicenses.map(function (license) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "Account-text"
    }, (0, _i18n["default"])("license.type.".concat(license.type)), " ", /*#__PURE__*/_react["default"].createElement("b", null, (0, _functions.displayLicenseAmount)(license)));
  })), isExpired ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-charge-container"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "Account-subtitle"
  }, "PLANO EXPIRADO"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Account-text"
  }, "Seu plano expirou em ", _i18n.format.datetime(expirationDate))) : !expirationDate ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-charge-container"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "Account-subtitle"
  }, "Sem data de vencimento"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Account-text"
  }, "Sua assinatura \xE9 para testes e por isso n\xE3o tem data de vencimento")) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-charge-container"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "Account-subtitle"
  }, "Ativo at\xE9 ", _i18n.format.datetime(expirationDate)), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Account-text"
  }, "Notificaremos sobre o vencimento da assinatura")), opportunities.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-charge-container"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "Account-subtitle"
  }, "Total: ", _i18n.format.currency(paidValue)), opportunities.map(function (opportunity) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "Account-text"
    }, opportunity.description || /*#__PURE__*/_react["default"].createElement("b", null, "OP #", opportunity.incremental), " de", ' ', _i18n.format.currency(opportunity.customerValue), " ", opportunity.paymentMethod === 'yearly' ? 'anual' : 'mensal');
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-charge-right"
  }, app === 'dokia' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-charge-container"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "Account-subtitle"
  }, "Armazenamento atual"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-progressContainer"
  }, /*#__PURE__*/_react["default"].createElement(_material.LinearProgress, {
    variant: "determinate",
    color: progressBarColor,
    value: Math.min(100, storagePercentage),
    sx: {
      height: 16,
      borderRadius: 8
    }
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Account-text"
  }, totalStorage === 'unlimited' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _functions.formatBytes)(usedStorage), " usados") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _functions.formatBytes)(usedStorage), " de ", (0, _functions.formatBytes)(totalStorage), " (", Math.floor(storagePercentage), "%) usados"))) : /*#__PURE__*/_react["default"].createElement("div", null), app === 'dokia' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-charge-warning"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-icon ".concat(almostReachingLimit ? 'Account-icon-almostExceeding' : 'Account-icon-underLimit')
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: almostReachingLimit ? 'faExclamationCircle' : 'faCheck'
  })), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "Account-subtitle"
  }, storageExceeded ? 'Armazenamento excedido' : "Voc\xEA atingiu ".concat(storagePercentage.toFixed(2), "% de armazenamento")), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Account-text"
  }, storageExceeded && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Voc\xEA excedeu o limite m\xE1ximo de ", (0, _functions.formatBytes)(totalStorage), /*#__PURE__*/_react["default"].createElement("br", null)), "Mantenha seus arquivos a salvo ", /*#__PURE__*/_react["default"].createElement("br", null), "N\xE3o fique sem espa\xE7o!"), /*#__PURE__*/_react["default"].createElement("button", {
    className: "Account-button Account-moreStorageButton",
    onClick: handleUpgradePlan
  }, "Mais armazenamento")) : /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-buttons"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "Account-button Account-upgradePlanButton",
    onClick: handleUpgradePlan
  }, "Atualizar plano"), /*#__PURE__*/_react["default"].createElement("button", {
    className: "Account-button Account-cancelPlanButton",
    onClick: handleCancelPlan
  }, "Cancelar plano"))));
}
var _default = Charge;
exports["default"] = _default;